/* eslint-disable no-underscore-dangle */

const serializeRecommendations = (recommendations) =>
  recommendations.map((item) => {
    let itemSerilized = {};
    if (item.__typename === 'Article') {
      itemSerilized = {
        ...item,
        brandName: item.brand.name,
        slug: item.slug,
        mediaType: item.__typename,
        thumbnail: item.thumbnail,
      };
    } else {
      itemSerilized = {
        ...item,
        brandName: item.brandName,
        slug: item.id,
        mediaType: item.mediaType,
        thumbnail: item.image,
      };
    }
    return itemSerilized;
  });

export default serializeRecommendations;
